import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logos">
        <div className="footer-pi-block">
          <div className="footer-pi-title">IADVL Presidential Initiative</div>
          <div className="footer-pi-sub">
            Wellness Plans by
            <img
              src="https://storecdn.goqii.com/media/goqiiweb/assets/images/site-logo.png"
              alt="GOQii"
              style={{ height: "20px" }}
            />
          </div>
        </div>
      </div>
      <p className="footer-text">
        Exclusive pricing for IADVL members &amp; their families. Insurance
        subject to underwriting terms. Wallets are annual, non-transferable.
        © 2026–27 IADVL Health Leadership Movement · IADVL Presidential
        Initiative Wellness Plans by GOQii Technologies Pvt. Ltd.
      </p>
    </footer>
  );
}
